import { requestOrThrow } from '../api-client'
import type { Store } from '../store'

export function getStoreDetail(idAlias: string) {
  return requestOrThrow<Store>(`stores/${idAlias}`)
}
